export default "__VITE_ASSET__Dpzq_ou4__"